<div class="contenedor-boton-volver">
    <ds-button-v2 label="Volver" emphasis="terciary" size="xs" [disabled]="false" [invert]="false"
        leadingIcon="ArrowBack" (clicked)="alHacerClicVolver()">
    </ds-button-v2>
</div>